module.exports = __webpack_public_path__ + "img/MFT白皮书_59.78f1032d.jpg";